import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck } from 'lucide-react';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}
const handleAddToCart = () => {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Explosive Baseball Power System',
      content_type: 'product',
      value: 6.75,
      currency: 'USD'
    });
  }
};
export function PricingCTA() {
  return <section id="pricing" className="py-24 bg-[#05080f] text-white relative overflow-hidden" data-id="element-33">
      {/* Background spotlight */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[400px] bg-blue-600/10 blur-[100px] rounded-t-full pointer-events-none" data-id="element-34" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-35">
        <div className="max-w-4xl mx-auto bg-[#0a0f1a] rounded-3xl border border-white/10 overflow-hidden shadow-2xl shadow-black/50" data-id="element-36">
          <div className="grid md:grid-cols-2" data-id="element-37">
            {/* Image Side */}
            <div className="relative h-64 md:h-auto overflow-hidden" data-id="element-38">
              <div className="absolute inset-0 bg-blue-900/20 mix-blend-overlay z-10" data-id="element-39" />
              <img src="https://cdn.magicpatterns.com/uploads/4i1ykHVGSKTzy1e8jbHzUL/hitting_power.png" alt="Product Cover" className="w-full h-full object-cover object-center transform scale-105" data-id="element-40" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0f1a] to-transparent opacity-80" data-id="element-41" />
              <div className="absolute bottom-6 left-6 right-6 z-20" data-id="element-42">
                <div className="text-amber-500 font-bold tracking-wider text-sm mb-1 uppercase" data-id="element-43">
                  Instant Access
                </div>
                <h3 className="text-2xl font-black text-white leading-none" data-id="element-44">
                  Explosive Baseball Power System
                </h3>
              </div>
            </div>

            {/* Content Side */}
            <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-45">
              <div className="mb-6" data-id="element-46">
                <span className="text-5xl font-black text-white tracking-tight" data-id="element-47">
                  $6.75
                </span>
                <span className="text-gray-500 ml-2 text-lg" data-id="element-48">
                  One-time payment
                </span>
              </div>

              <p className="text-gray-300 mb-8 leading-relaxed" data-id="element-49">
                You're not buying pages. You're buying a mechanism you can run
                in-season, off-season, and during slumps without guessing.
              </p>

              <div className="space-y-4" data-id="element-50">
                <a href="https://baseballstrengthpro.com/cart/51939815915801:1" onClick={handleAddToCart} className="w-full group relative flex items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all duration-200 bg-blue-600 rounded-lg hover:bg-blue-500 hover:shadow-[0_0_30px_rgba(59,130,246,0.4)]" data-id="element-51">
                  <span data-id="element-52">Get the 30-Day Power System</span>
                  <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-53" />
                </a>

                <button className="w-full flex items-center justify-center px-8 py-3 text-sm font-semibold text-gray-400 hover:text-white transition-colors" data-id="element-54">
                  Turn My Power Back On
                </button>
              </div>

              <div className="mt-8 pt-6 border-t border-white/5 flex items-center justify-center gap-2 text-xs text-gray-500 uppercase tracking-widest" data-id="element-55">
                <ShieldCheck size={14} data-id="element-56" />
                <span data-id="element-57">Secure Payment • Instant Delivery</span>
              </div>
            </div>
          </div>
        </div>

        {/* Final Motivational Line */}
        <div className="mt-16 text-center max-w-2xl mx-auto" data-id="element-58">
          <p className="text-xl md:text-2xl font-medium text-gray-300" data-id="element-59">
            "Get the PDF. Run the 30-day plan. Track what matters. <br data-id="element-60" />
            <span className="text-white font-bold" data-id="element-61">
              And become the hitter who doesn't disappear.
            </span>
            "
          </p>
        </div>
      </div>
    </section>;
}